import { render, staticRenderFns } from "./ResponsiveRowMedium.vue?vue&type=template&id=0a7f9a20&scoped=true"
import script from "./ResponsiveRowMedium.vue?vue&type=script&lang=ts"
export * from "./ResponsiveRowMedium.vue?vue&type=script&lang=ts"
import style0 from "./ResponsiveRowMedium.vue?vue&type=style&index=0&id=0a7f9a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7f9a20",
  null
  
)

export default component.exports